module.exports = __webpack_public_path__ + "static/media/close.389c9fd3.svg";